var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.item.name_prefix)+" "+_vm._s(_vm.item.name))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.item.license_plate))]),_c('br'),_c('strong',[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.item.tel))])])])}
var staticRenderFns = []

export { render, staticRenderFns }